var CatalogService = /** @class */ (function () {
    function CatalogService(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * @param id
     * @returns FilingCardStateResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    CatalogService.prototype.catalogGetFilingCardStateById = function (id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/card-state-rule/{id}',
            path: {
                'id': id,
            },
        });
    };
    /**
     * @returns FilingCardStatesResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    CatalogService.prototype.catalogGetFilingCardStates = function () {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/card-state-rules',
        });
    };
    /**
     * Initiates data fetching from notion and updates internal database
     * @param requestBody
     * @returns FetchFromNotionResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    CatalogService.prototype.catalogFetchFromNotion = function (requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/catalog/sync',
            body: requestBody,
            mediaType: 'application/json',
        });
    };
    /**
     * Gets all courses
     * @returns GetCoursesResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    CatalogService.prototype.catalogGetCourses = function () {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/courses',
        });
    };
    /**
     * Gets all courses categories
     * @returns GetCourseCategoriesResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    CatalogService.prototype.catalogGetCourseCategories = function () {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/courses-categories',
        });
    };
    /**
     * Get course by id
     * @param id
     * @returns GetCourseResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    CatalogService.prototype.catalogGetCourse = function (id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/courses/{id}',
            path: {
                'id': id,
            },
        });
    };
    /**
     * @returns GetDeductionsResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    CatalogService.prototype.catalogGetDeductions = function () {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/deductions',
        });
    };
    /**
     * Get all offer for selected funnel
     * @param sku
     * @returns GetFunnelResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    CatalogService.prototype.catalogGetFunnelOffers = function (sku) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/funnel/{sku}',
            path: {
                'sku': sku,
            },
        });
    };
    /**
     * Gets all products from catalog
     * @returns GetAllFunnelsResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    CatalogService.prototype.catalogGetAllFunnels = function () {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/funnels',
        });
    };
    /**
     * Gets info about one prduct by sku or id
     * @param sku
     * @returns GetProductResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    CatalogService.prototype.catalogGetProduct = function (sku) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/product/{sku}',
            path: {
                'sku': sku,
            },
        });
    };
    /**
     * Gets all products from catalog
     * @returns GetProductsResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    CatalogService.prototype.catalogGetProducts = function () {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/products',
        });
    };
    /**
     * Gets only active products
     * @returns GetProductsResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    CatalogService.prototype.catalogGetActiveProducts = function () {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/products/active',
        });
    };
    /**
     * @param sku
     * @returns GetProductsResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    CatalogService.prototype.catalogGetProductsBySku = function (sku) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/products/by-sku',
            query: {
                'sku': sku,
            },
        });
    };
    /**
     * @returns ResourceVaultRecordResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    CatalogService.prototype.catalogGetResouceVaultRecords = function () {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/resource_vault_records',
        });
    };
    /**
     * @returns ResourceVaultSectionResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    CatalogService.prototype.catalogGetResourceVaultSections = function () {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/resource_vault_sections',
        });
    };
    /**
     * Gets available stickies
     * @returns GetStickiesResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    CatalogService.prototype.catalogGetStickies = function () {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/stickies',
        });
    };
    /**
     * Get sticky by id
     * @param id
     * @returns GetStickyResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    CatalogService.prototype.catalogGetSticky = function (id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/stickies/{id}',
            path: {
                'id': id,
            },
        });
    };
    return CatalogService;
}());
export { CatalogService };
//# sourceMappingURL=CatalogService.js.map